import { render, staticRenderFns } from "./AnimalTypeTab.vue?vue&type=template&id=76f010a6&scoped=true"
import script from "./AnimalTypeTab.vue?vue&type=script&lang=js"
export * from "./AnimalTypeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f010a6",
  null
  
)

export default component.exports